import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useAuth } from "@/contexts/AuthContext";
import { loadUserProgress, type UserProgress } from "@/lib/progress";

/**
 * Shared, cached progress query. Replaces the per-page
 * `useEffect(() => loadUserProgress(...).then(setProgress), [user])`
 * pattern that was refetching on every navigation.
 */
export function useUserProgress() {
  const { user } = useAuth();
  return useQuery<UserProgress>({
    queryKey: ["user-progress", user?.id],
    queryFn: () => loadUserProgress(user!.id),
    enabled: !!user,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    refetchOnWindowFocus: false,
  });
}

export function useInvalidateProgress() {
  const qc = useQueryClient();
  const { user } = useAuth();
  return () => qc.invalidateQueries({ queryKey: ["user-progress", user?.id] });
}
